module.exports = __webpack_public_path__ + "static/textscale-96d31417af89163cf04fd1eb84fbe8a6.png";